/* Deterministic navigation helpers for flexible customizer steps. */
(() => {
  const key = step => String(typeof step === 'string' ? step : step?.step || '').toLowerCase();

  function normalizePricing(value) {
    const pricing = value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    if (!Object.prototype.hasOwnProperty.call(pricing, 'fotos_qty')) pricing.fotos_qty = null;
    if (!Object.prototype.hasOwnProperty.call(pricing, 'fotos_addon_variant_id')) pricing.fotos_addon_variant_id = null;
    if (!pricing.extras || typeof pricing.extras !== 'object' || Array.isArray(pricing.extras)) pricing.extras = {};
    return pricing;
  }

  function chooseOptional(steps, currentIndex, enabled) {
    if (!Array.isArray(steps)) throw new Error('invalid_steps');
    const current = steps[currentIndex];
    const currentKey = key(current);
    if (!current || !currentKey.startsWith('extra_') || !current.conditional_step?.step) {
      throw new Error('invalid_optional_step');
    }

    current.enabled_by_user = enabled === true;
    const nextSteps = steps.filter(step => step?._tacConditionalFor !== currentKey);
    const stableIndex = nextSteps.findIndex(step => key(step) === currentKey);
    if (stableIndex < 0) throw new Error('optional_step_missing');

    if (enabled === true) {
      nextSteps.splice(stableIndex + 1, 0, {
        ...current.conditional_step,
        _tacConditionalFor: currentKey
      });
    }

    return {
      steps: nextSteps,
      currentIndex: stableIndex,
      nextIndex: Math.min(stableIndex + 1, nextSteps.length - 1),
      currentKey,
      nextKey: key(nextSteps[Math.min(stableIndex + 1, nextSteps.length - 1)])
    };
  }

  window.TACStepFlow = Object.freeze({ key, normalizePricing, chooseOptional });
})();
